/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_Agent_InstructionsInputs */

const en_rd_check_agent_instructions = /** @type {(inputs: Rd_Check_Agent_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent instructions file`)
};

const id_rd_check_agent_instructions = /** @type {(inputs: Rd_Check_Agent_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berkas instruksi agent`)
};

/**
* | output |
* | --- |
* | "Agent instructions file" |
*
* @param {Rd_Check_Agent_InstructionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_agent_instructions = /** @type {((inputs?: Rd_Check_Agent_InstructionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_Agent_InstructionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_agent_instructions(inputs)
	return en_rd_check_agent_instructions(inputs)
});